import React from 'react'

import LinkedCalendars from './LinkedCalendars'

import './index.scss'

const MyCalendars = () => (
  <div className="my-calendars-comp">
    <div className="body">
      <div className="synced-calendars">
        <LinkedCalendars />
      </div>
    </div>
  </div>
)

export default MyCalendars
